export default "__VITE_ASSET__Cr374R$J__"